import * as React from "react";
import { ChevronDown, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@repo/ui";

/** Outline trigger for a toolbar dropdown that shows its current value. */
export const PickerButton = React.forwardRef<
  HTMLButtonElement,
  Omit<React.ComponentPropsWithoutRef<typeof Button>, "size"> & {
    icon?: LucideIcon;
    label: React.ReactNode;
    size?: "sm" | "xs";
  }
>(({ icon: Icon, label, size = "sm", className, ...props }, ref) => {
  const iconClass = cn("shrink-0 text-muted-foreground", size === "sm" ? "!size-3.5" : "!size-3");
  return (
    <Button
      ref={ref}
      type="button"
      variant="outline"
      size="sm"
      className={cn(
        "max-w-48 font-normal",
        size === "sm" ? "h-8 gap-1.5 px-2.5" : "h-6 gap-1 rounded px-1.5 text-xs",
        className,
      )}
      {...props}
    >
      {Icon && <Icon className={iconClass} />}
      <span className="truncate">{label}</span>
      <ChevronDown className={iconClass} />
    </Button>
  );
});
PickerButton.displayName = "PickerButton";
